import { PAYMENT_TYPE } from '../utils/constants';
import { makeError } from '../utils/error';

export type SchedulePayment = {
  type: string;
  planCode?: string;
  healthInsuranceId?: string;
  nome: string;
};

export const SchedulePaymentBuilder = (type: string) => {
  const schedulePayment = {} as SchedulePayment;
  schedulePayment.type = type;

  const build = () => {
    checkPropertyError();
    return schedulePayment;
  };

  const checkPropertyError = () => {
    if (!schedulePayment.type) makeError(`Missing type property `);
    if (schedulePayment.type === PAYMENT_TYPE.B2B) {
      if (!schedulePayment.planCode) makeError(`Missing planCode property `);
      if (!schedulePayment.healthInsuranceId) makeError(`Missing healthInsuranceId property `);
      if (!schedulePayment.nome) makeError(`Missing nome property `);
    }
  };

  const setHelthInsuranceId = (idInsurance: string) => {
    if (schedulePayment.type === PAYMENT_TYPE.B2B) schedulePayment.healthInsuranceId = idInsurance;
  };

  const setPlanCode = (codPlan: string) => {
    if (schedulePayment.type === PAYMENT_TYPE.B2B) schedulePayment.planCode = codPlan;
  };

  const setName = (name: string) => {
    if (schedulePayment.type === PAYMENT_TYPE.B2B) schedulePayment.nome = name;
  };

  return { setHelthInsuranceId, setPlanCode, setName, build };
};
